import TextField from "../../../components/fields/textField/TextField.vue";
import PeriodoField from "../../../components/fields/periodoField/PeriodoField.vue";
import SelectField from "../../../components/fields/selectField/SelectField.vue";
import {
  FeriasService
} from "../../../services/FeriasService";

export default {
  name: "FeriasProrrogadas",

  components: {
    TextField,
    PeriodoField,
    SelectField
  },

  data: () => ({
    headers: [{
        text: "Nome",
        value: "nome",
        sortable: false
      },
      {
        text: "Tipo Alteração",
        value: "tipo_alteracoes",
        sortable: false
      },
      {
        text: "Motivo",
        value: "entidade_tipo_alteracao",
        sortable: false
      },
      {
        text: "Período",
        value: "periodo",
        sortable: false
      }
    ],

    items: [],
    page: 1,
    paginacao:[],
    pageCount: 0,
    totalItems: 0,
    lastPage:[],



    loading: {
      table: false
    }
  }),

  mounted() {
    this.pegarFeriasInterrompidas();
  },

  watch: {
    page: async function() {
      await this.pegarFeriasInterrompidas();
    }
  },

  methods: {
    async pegarFeriasInterrompidas() {
      this.loading.table = true;
      const response = await FeriasService.getFeriasProrrogadas(this.page, this.$store.state.perfil_id);
      this.items = response.data;
      this.paginacao = response;
      this.pageCount = Math.ceil(response.total / 10);
      this.totalItems = response.total;
      this.loading.table = false;     
    },
    close() {
      this.$emit("on-close");
    },
  }

};